import React from 'react';
import './Privacypolicy.css';
import Header from './Header';
import Footer from './Footer';

const Privacypolicy = () => {
    return (
        <div>
            <Header />
            <div className="nd-privacy-page">
                <div className="nd-privacy-container container">
                    <div className="nd-privacy-hero">
                        <div className="nd-privacy-badge">Privacy & Data Protection</div>
                        <h1 className="nd-privacy-title">Privacy Policy</h1>
                    </div>

                    <div className="nd-privacy-lead-card">
                        <p>
                            At N D Techland Private Limited ("we," "our," "us"), we take the privacy and security of your personal information seriously. This Privacy Policy explains how we collect, use, share, and protect your information when you use our services, including the N D Connect platform.
                        </p>
                        <p>
                            By accessing or using our website or services, you agree to this Privacy Policy. If you do not agree, please discontinue use of our services.
                        </p>
                        <p>
                            Please note: This Privacy Policy may be updated at any time to reflect changes in our practices or in compliance with government regulations and guidelines. Any changes will be posted on our website, and we encourage you to review this policy periodically.
                        </p>
                    </div>

                    <div className="nd-privacy-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">01</span>
                                <h5><strong>1. Information We Collect</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>We collect various types of information to provide you with personalized and efficient services.</p>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>1.1 Personal Information</strong></h6>
                                    <p>Personal information is data that identifies you as an individual. This may include:</p>
                                    <ul className="nd-privacy-list">
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Name:</strong> Your full name.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Email address:</strong> Your email address for communication.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Phone number:</strong> Your contact number.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Company name:</strong> The name of your company.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Billing information:</strong> Information required for billing.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Login credentials:</strong> Username and password for account access.</span></li>
                                    </ul>
                                </div>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>1.2 Non-Personal Information</strong></h6>
                                    <p>Non-personal information refers to data that does not directly identify you, such as:</p>
                                    <ul className="nd-privacy-list">
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>IP address:</strong> Your internet protocol address.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Browser type and version:</strong> Information about the browser you use.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Device and operating system details:</strong> The device and OS you are using.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Location data:</strong> Location for attendance validation.</span></li>
                                        <li><span className="nd-privacy-list-dot"></span><span><strong>Service usage patterns:</strong> Patterns including time and duration of access.</span></li>
                                    </ul>
                                </div>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>1.3 Cookies and Tracking Technologies</strong></h6>
                                    <p>We use cookies and similar tracking technologies to enhance your experience, gather analytics, and ensure seamless login. You may adjust your browser settings to refuse cookies; however, doing so may limit certain features of our service.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">02</span>
                                <h5><strong>2. How We Use Your Information</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>We use the information we collect for the following purposes:</p>
                                <ul className="nd-privacy-list">
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Service Provision:</strong> To enable access to the N D Connect platform and its features, such as customer management, invoicing, employee tracking, and payment reminders.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Communication:</strong> To send service updates, marketing materials, technical notices, and other administrative messages.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Service Improvement:</strong> To analyze usage patterns and feedback to enhance and optimize our services.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Legal Compliance:</strong> To comply with applicable laws and regulations and enforce our agreements.</span></li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">03</span>
                                <h5><strong>3. How We Share Your Information</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>Your personal information is only shared under specific circumstances:</p>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>3.1 With Third-Party Service Providers</strong></h6>
                                    <p>We work with third-party vendors who assist us in delivering our services. These providers are only given access to your information to perform specific services on our behalf and are obligated to maintain confidentiality.</p>
                                </div>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>3.2 For Legal Purposes</strong></h6>
                                    <p>We may disclose your information if required by law or if we believe such action is necessary to protect our rights or comply with legal obligations.</p>
                                </div>

                                <div className="nd-privacy-subitem">
                                    <h6><strong>3.3 Business Transactions</strong></h6>
                                    <p>In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of the transaction.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">04</span>
                                <h5><strong>4. Data Security</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>We employ industry-standard security measures to protect your personal information from unauthorized access, disclosure, or destruction. Our security protocols include:</p>
                                <ul className="nd-privacy-list">
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Encryption of sensitive data:</strong> Protecting sensitive data through encryption methods.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Secure data storage practices:</strong> Storing data securely to prevent unauthorized access.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Limiting access to authorized personnel only:</strong> Ensuring that only authorized individuals can access personal information.</span></li>
                                </ul>
                                <p style={{ marginTop: '16px' }}>
                                    Despite our efforts, no method of data transmission or storage can be guaranteed to be 100% secure. We cannot promise absolute security, but we are committed to protecting your data to the best of our abilities.
                                </p>
                            </div>
                        </div>

                        {/* Section 5 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">05</span>
                                <h5><strong>5. Data Retention</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>We retain personal data for as long as necessary to fulfill the purposes for which it was collected or as required by law. Once your information is no longer needed, we will securely delete or anonymize it in compliance with data protection regulations.</p>
                            </div>
                        </div>

                        {/* Section 6 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">06</span>
                                <h5><strong>6. Employee Location for Attendance Validation</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>The N D Connect platform may collect employee location data from mobile devices for attendance validation. This ensures that attendance is accurately recorded based on the verified work location as designated by the employer. The data is used solely for attendance verification purposes and will not be shared with third parties unless required by law.</p>
                            </div>
                        </div>

                        {/* Section 7 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">07</span>
                                <h5><strong>7. Your Rights</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>You have the following rights regarding your personal data:</p>
                                <ul className="nd-privacy-list">
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Access:</strong> You can request access to the personal information we hold about you.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Correction:</strong> You can ask us to update or correct any inaccurate data.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Deletion:</strong> You can request that we delete your personal data, subject to certain legal obligations.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Opt-Out:</strong> You can opt out of marketing communications at any time.</span></li>
                                    <li><span className="nd-privacy-list-dot"></span><span><strong>Data Portability:</strong> You may request a copy of your data in a machine-readable format.</span></li>
                                </ul>
                                <p style={{ marginTop: '16px' }}>To exercise these rights, please contact us at <a href="mailto:info@ndtechland.com">info@ndtechland.com</a>.</p>
                            </div>
                        </div>

                        {/* Section 8 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">08</span>
                                <h5><strong>8. Children’s Privacy</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>Our services are not directed toward children under the age of 18. We do not knowingly collect personal information from children. If we become aware of data collection from children, we will take steps to delete such information promptly.</p>
                            </div>
                        </div>

                        {/* Section 9 */}
                        <div className="nd-privacy-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">09</span>
                                <h5><strong>9. Changes to This Privacy Policy</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>We reserve the right to modify this Privacy Policy at any time in accordance with changes in company practices, services, or applicable laws and government guidelines. Any changes will be posted on our website. It is your responsibility to review this policy periodically to stay informed about our data practices.</p>
                            </div>
                        </div>

                        {/* Section 10 - Contact Us */}
                        <div className="nd-privacy-card nd-privacy-contact-card">
                            <div className="nd-privacy-card-header">
                                <span className="nd-privacy-num">📞</span>
                                <h5><strong>10. Contact Us</strong></h5>
                            </div>
                            <div className="nd-privacy-card-body">
                                <p>If you have any questions or concerns regarding this Privacy Policy or how we handle your data, please contact us at:</p>

                                <div className="nd-privacy-contact-grid">
                                    <div className="nd-privacy-contact-item">
                                        <span className="nd-privacy-contact-label">Company</span>
                                        <span className="nd-privacy-contact-val">N D Techland Private Limited</span>
                                    </div>
                                    <div className="nd-privacy-contact-item">
                                        <span className="nd-privacy-contact-label">Email</span>
                                        <span className="nd-privacy-contact-val"><a href="mailto:info@ndtechland.com">info@ndtechland.com</a></span>
                                    </div>
                                    <div className="nd-privacy-contact-item">
                                        <span className="nd-privacy-contact-label">Phone</span>
                                        <span className="nd-privacy-contact-val">+91 8826302378</span>
                                    </div>
                                    <div className="nd-privacy-contact-item">
                                        <span className="nd-privacy-contact-label">Website</span>
                                        <span className="nd-privacy-contact-val"><a href="https://www.ndtechland.com" target="_blank" rel="noopener noreferrer">www.ndtechland.com</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Privacypolicy;
